module.exports = __webpack_public_path__ + "static/img/5.0bb382b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/eng/5.png
// module id = kta3
// module chunks = 0